import ProcDayPicker from '../ui/ProcDayPicker'
import { PROC_FREQ_VALUES } from './cardDetailUtils'

export default function CardProcedureLinkPanel({
    t,
    cardProcedures,
    procedures,
    isAdmin,
    linkingProcedure,
    setLinkingProcedure,
    linkingSchedule,
    setLinkingSchedule,
    linkingProcLoading,
    setLinkingProcLoading,
    linkProcedure,
    userId,
    fetchChecklists,
    showAchievement,
    getProcedureChecklistStats,
}) {
    if (cardProcedures.length === 0) return null

    return (
        <div>
            <div className="cd-proc-summary">
                <span>
                    {t('card.procedures.summary.completed', {
                        done: cardProcedures.filter((cardProcedure) => getProcedureChecklistStats(cardProcedure).isComplete).length,
                        total: cardProcedures.length,
                    })}
                </span>
                <span>
                    {t('card.procedures.summary.averageProgress', {
                        percent: Math.round(cardProcedures.reduce((acc, cardProcedure) => acc + getProcedureChecklistStats(cardProcedure).progress, 0) / cardProcedures.length),
                    })}
                </span>
            </div>

            {isAdmin && procedures.length > 0 && (
                <div className="cd-proc-link-form">
                    <select
                        value={linkingProcedure}
                        onChange={(event) => {
                            const procId = event.target.value
                            setLinkingProcedure(procId)
                            const procedure = procedures.find((candidate) => candidate.id === procId)
                            setLinkingSchedule({
                                frequency: procedure?.frequency ?? 'daily',
                                repeat_interval: procedure?.repeat_interval ?? 1,
                                repeat_days: procedure?.repeat_days ?? [],
                            })
                        }}
                    >
                        <option value="">{t('card.procedures.pick')}</option>
                        {procedures
                            .filter((procedure) => !cardProcedures.some((cardProcedure) => cardProcedure.procedure_id === procedure.id))
                            .map((procedure) => (
                                <option key={procedure.id} value={procedure.id}>{procedure.title}</option>
                            ))}
                    </select>

                    {linkingProcedure && (
                        <div className="cd-proc-schedule-form">
                            <div className="proc-schedule-row">
                                <select
                                    className="proc-input cd-proc-sched-select"
                                    value={linkingSchedule.frequency}
                                    onChange={(event) => setLinkingSchedule((schedule) => ({ ...schedule, frequency: event.target.value, repeat_days: [] }))}
                                >
                                    {PROC_FREQ_VALUES.map((value) => <option key={value} value={value}>{t(`card.schedule.freq.${value}`)}</option>)}
                                </select>
                                <label className="proc-schedule-label">
                                    {t('card.procedures.everyLabel')}
                                    <input
                                        type="number"
                                        className="proc-interval-input"
                                        min={1}
                                        max={99}
                                        value={linkingSchedule.repeat_interval}
                                        onChange={(event) => setLinkingSchedule((schedule) => ({ ...schedule, repeat_interval: Math.max(1, Number(event.target.value)) }))}
                                    />
                                    {t(`card.schedule.unit.${linkingSchedule.frequency}`, { defaultValue: '' })}
                                </label>
                            </div>
                            <div className="proc-schedule-row">
                                <span className="proc-schedule-label">{t('card.procedures.daysLabel')}</span>
                                <ProcDayPicker
                                    value={linkingSchedule.repeat_days}
                                    onChange={(days) => setLinkingSchedule((schedule) => ({ ...schedule, repeat_days: days }))}
                                />
                            </div>
                        </div>
                    )}

                    <button
                        onClick={async () => {
                            if (!linkingProcedure || linkingProcLoading) return
                            setLinkingProcLoading(true)
                            const result = await linkProcedure(linkingProcedure, userId, linkingSchedule)
                            setLinkingProcLoading(false)
                            if (!result?.success) {
                                showAchievement({ type: 'error', message: result?.error || t('card.procedures.linkError') })
                                return
                            }
                            setLinkingProcedure('')
                            setLinkingSchedule({ frequency: 'daily', repeat_interval: 1, repeat_days: [] })
                            fetchChecklists()
                            showAchievement({ type: 'badge', message: t('card.procedures.linked') })
                        }}
                        disabled={!linkingProcedure || linkingProcLoading}
                    >
                        {linkingProcLoading ? t('card.procedures.linking') : t('card.procedures.link')}
                    </button>
                </div>
            )}
        </div>
    )
}
